import script from "./ButtonsRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./ButtonsRow.vue?vue&type=script&lang=ts&setup=true"

import "./ButtonsRow.vue?vue&type=style&index=0&id=160f7112&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-160f7112"]])

export default __exports__